'use strict'

import ApiClient from './ApiClient'

export default class NeoConnectionRepository {
  /**
   * desknet's NEO 接続設定を取得します。
   */
  get () {
    return ApiClient().get(`/neoconnections`)
  }

  /**
   * desknet's NEO 接続設定を更新します。
   * @param {object} params
   */
  put (params) {
    return ApiClient().put(`/neoconnections`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/NeoConnectionRepository.js